import { PumpBM } from 'src/types/BusinessModel/PumpBM';
import { Pump } from 'src/types/ViewModel/Pump';

export class PumpFactory {
    public create(data: PumpBM): Pump {
        return new Pump(data.pumpId, data.runningHours);
    }

    public createBM(pumpId: number, runningHours?: number): PumpBM {
        return {
            pumpId: pumpId,
            runningHours: runningHours,
        };
    }

    public createList(data: PumpBM[]): Pump[] {
        return data.map((h) => this.create(h));
    }
}
